import { Grid, styled, Tab, Tabs } from "@mui/material";
import { useSelector } from "react-redux";

function BasketHistoryTabs({ typeId, handleChange }) {
  const basketHistoryForm = useSelector((state) => state.wallet.basketHistoryForm?.data)

  return (
    <Grid item xs={12}>
      <TabsStyle value={typeId} onChange={handleChange}>
        {basketHistoryForm?.lisType?.map((type) => (
          <Tab label={type?.name} value={type?.id} />
        ))}
      </TabsStyle>
    </Grid>
  );
}

const TabsStyle = styled(Tabs)(({ theme }) => ({
  borderBottom: `1px solid ${theme.palette.modules.border}`,
  marginTop: theme.spacing(3),
  marginBottom: theme.spacing(3),

  ".MuiTabs-flexContainer": {
    justifyContent: "space-around",
  },
}));
export default BasketHistoryTabs;
